import styled from "styled-components"
import {H4} from "@irati/ui/src/Typography"

export default styled(H4)`
  margin-bottom: ${({theme}) => theme.spacing.two}
`
